import React from 'react';
import { Close as XIcon } from '@mui/icons-material';
import { T, fontDisplay, fontBody } from '../tokens';

export default function FlowToolbar({
  template,
  isNew,
  onPreview,
  onSave,
  onClose,
  previewLoading,
  saving,
  isValid,
  saveError,
  onClearSaveError,
}) {
  const isChannelDefault = !isNew && template?.isChannelDefault;

  return (
    <div style={{ borderBottom: `1px solid ${T.line}`, background: T.card }}>
    <div style={{
      display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      padding: '16px 22px',
    }}
    >
      <div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div style={{ fontFamily: fontDisplay, fontSize: 17, fontWeight: 600, color: T.ink }}>
            {isNew ? 'New automation' : (template.name || 'Edit automation')}
          </div>
          {isChannelDefault && (
            <span style={{
              display: 'inline-flex', alignItems: 'center', gap: 4,
              padding: '2px 8px', borderRadius: 999,
              background: '#F0FDF4', border: '1px solid #BBF7D0',
              fontFamily: fontBody, fontSize: 11, fontWeight: 700, color: '#15803D',
            }}
            >
              DEFAULT
            </span>
          )}
        </div>
        <div style={{ fontFamily: fontBody, fontSize: 12, color: T.slate }}>
          Visual flow builder
        </div>
      </div>
      <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap', justifyContent: 'flex-end' }}>
        <button
          type="button"
          onClick={onPreview}
          disabled={previewLoading}
          style={{
            fontFamily: fontBody, fontSize: 13, fontWeight: 600,
            color: T.ink, background: 'transparent', border: `1px solid ${T.line}`,
            padding: '8px 14px', borderRadius: 9, cursor: 'pointer',
          }}
        >
          {previewLoading ? 'Testing…' : 'Test flow'}
        </button>
        <button
          type="button"
          disabled={saving || !isValid}
          onClick={onSave}
          style={{
            fontFamily: fontBody, fontSize: 13, fontWeight: 600, color: '#fff',
            background: isValid ? T.blue : T.slateLight,
            border: 'none', padding: '8px 16px', borderRadius: 9,
            cursor: isValid ? 'pointer' : 'not-allowed',
          }}
        >
          {saving
            ? (isNew ? 'Activating…' : 'Saving…')
            : (isNew ? 'Activate' : 'Save')}
        </button>
        <button type="button" onClick={onClose} style={{ border: 'none', background: 'transparent', cursor: 'pointer', marginLeft: 4 }}>
          <XIcon sx={{ fontSize: 20, color: T.slateLight }} />
        </button>
      </div>
    </div>
    {saveError && (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '8px 22px', background: '#FEF2F2', borderTop: '1px solid #FECACA',
      }}
      >
        <span style={{ fontFamily: fontBody, fontSize: 13, color: '#DC2626' }}>{saveError}</span>
        {onClearSaveError && (
          <button
            type="button"
            onClick={onClearSaveError}
            style={{ border: 'none', background: 'transparent', cursor: 'pointer', color: '#DC2626', fontFamily: fontBody, fontSize: 13, fontWeight: 600, padding: '0 4px' }}
          >
            ×
          </button>
        )}
      </div>
    )}
    </div>
  );
}
